var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3593({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1319 17.3363C28.3877 18.6223 28.2564 19.9553 27.7546 21.1667C27.2528 22.3781 26.4031 23.4135 25.3129 24.142C24.823 24.4693 24.2945 24.728 23.742 24.9137V27.7778H20.9272V24.971C20.7435 24.7897 20.6296 24.5378 20.6296 24.2593C20.6296 23.707 21.0773 23.2593 21.6296 23.2593C22.5453 23.2593 23.4404 22.9877 24.2017 22.479C24.9631 21.9703 25.5564 21.2473 25.9068 20.4013C26.2573 19.5554 26.3489 18.6245 26.1703 17.7264C25.9917 16.8284 25.5507 16.0035 24.9033 15.356C24.2558 14.7085 23.4309 14.2676 22.5328 14.089C21.6348 13.9103 20.7039 14.002 19.8579 14.3524C19.012 14.7028 18.2889 15.2962 17.7802 16.0575C17.2715 16.8189 17 17.714 17 18.6296C17 19.1819 16.5523 19.6296 16 19.6296C15.4477 19.6296 15 19.1819 15 18.6296C15 17.3184 15.3888 16.0366 16.1173 14.9464C16.8458 13.8562 17.8812 13.0064 19.0926 12.5047C20.304 12.0029 21.637 11.8716 22.923 12.1274C24.209 12.3832 25.3903 13.0146 26.3175 13.9418C27.2447 14.8689 27.8761 16.0502 28.1319 17.3363ZM23.742 29.1852H20.9272V32H23.742V29.1852Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 4.5,
    stroke: "#747BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3593);
export default __webpack_public_path__ + "static/media/Group 3593.77ca1f965e8d12824a0af122976499fe.svg";
export { ForwardRef as ReactComponent };